<div *ngIf="loader" class="loader-backdrop">
  <div class="loader-card">
    <ion-spinner></ion-spinner>
    <p>Cargando</p>
  </div>
</div>
<div class="content">
  <router-outlet></router-outlet>
</div>
<app-main-loader *ngIf="loadingSession"></app-main-loader>
